const tableData = [
  { feature: "Product Discovery", spreadsheet: "Fast & Organized", manual: "Slow & Scattered" },
  { feature: "Category Organization", spreadsheet: "Excellent Structure", manual: "No Organization" },
  { feature: "Product Comparison", spreadsheet: "Easy Side-by-Side", manual: "Difficult to Compare" },
  { feature: "Beginner Friendly", spreadsheet: "Very Easy to Use", manual: "Requires Experience" },
  { feature: "QC Photo Access", spreadsheet: "Community Verified", manual: "Hard to Find" },
  { feature: "Updated Listings", spreadsheet: "Regularly Refreshed", manual: "Often Outdated" },
  { feature: "Safety Awareness", spreadsheet: "Built-in Guidelines", manual: "No Protection" },
  { feature: "Time Efficiency", spreadsheet: "Minutes to Browse", manual: "Hours of Searching" },
];

export default function ComparisonTable() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Why Use <span className="text-primary-500">Vigorbuy Spreadsheet</span>?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            See how the Vigorbuy spreadsheet compares to traditional manual product searching. The difference is clear.
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden border border-background-200/70 bg-background-50">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-primary-500">
                  <th className="text-left px-5 py-4 text-sm font-semibold text-background-50 whitespace-nowrap">Feature</th>
                  <th className="text-left px-5 py-4 text-sm font-semibold text-background-50 whitespace-nowrap">
                    <i className="ri-checkbox-circle-fill mr-1.5"></i>
                    Vigorbuy Spreadsheet
                  </th>
                  <th className="text-left px-5 py-4 text-sm font-semibold text-background-50 whitespace-nowrap">
                    <i className="ri-close-circle-fill mr-1.5"></i>
                    Manual Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, idx) => (
                  <tr
                    key={row.feature}
                    className={`border-t border-background-200/70 ${
                      idx % 2 === 0 ? "bg-background-50" : "bg-background-100/60"
                    } hover:bg-primary-50/40 transition-colors`}
                  >
                    <td className="px-5 py-3.5 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="px-5 py-3.5 text-sm text-primary-700 font-medium whitespace-nowrap">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-check-line text-primary-500"></i>
                        {row.spreadsheet}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-foreground-400 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-close-line text-accent-500"></i>
                        {row.manual}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap no-underline shadow-lg shadow-primary-500/25"
          >
            <i className="ri-arrow-right-circle-line text-lg"></i>
            <span>Try Vigorbuy Spreadsheet Now</span>
          </a>
        </div>
      </div>
    </section>
  );
}